<template>
  <div class="quick-actions">
    <header class="quick-actions-header">
      <AvatarImage  v-if="entity"
                    size="x-sm"
                    :imagePath="entity.photoPath"
                    :name="entity.fullName"
                    :color-id="entity.colorId"/>
      <span class="header-title">
        {{$t('common.quick_actions_menu.engage_with_vue', {client: this.entity.fullName})}}
      </span>
    </header>
    <ul>
      <li v-for="action in actionsToDisplay"
          :key="action.name"
          @click="onClick(action)">
        <div class="action-box">
          <VSvgIcon tag="24" size="24" :icon="action.icon" class="quick-action-icon"/>
          <div class="action-title" v-html="$t(action.text)"></div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import quickActionsUtil from './quickActionsUtil'
import {VSvgIcon, AvatarImage} from '@/modules/common/components'

export default {
  name: 'QuickActions',
  components: {
    VSvgIcon,
    AvatarImage,
  },
  props: {
    actions: {
      type: Array,
      required: true
    },
    entity: {
      type: Object,
      required: false
    }
  },
  computed: {
    actionsToDisplay() {
      return quickActionsUtil.pick(...this.actions)
    },
  },
  methods: {
    onClick(action) {
      this.$emit('actionClicked', action)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";

.quick-actions {
  background-color: $white-color-1;
  width: 100%;
  padding: 10px 13px 0;
  margin: 0;

  .quick-actions-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 6px 0;

    .header-title {
      margin: 0 7px;
      color: $color_dark_text;
      font-weight: 600;
      font-size: 12px;
      font-family: var(--font2);
    }
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    height: 100%;

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  li {
    flex: 1 1 33%;
    max-width: 33.33%;
    max-height: 100%;
    box-sizing: border-box;
  }

  .action-box {
    margin: 4px 2px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 88px;
    text-align: center;
    font-weight: 500;
    font-size: 12px;
    border: 1px solid transparent;
    cursor: pointer;

    &:hover {
      border-color: $actionDotsHover;
    }

    .action-title {
      font-size: 12px;
      font-weight: 500;
      font-family: var(--primary-font-family);
      margin: 5px;
    }
  }
}
</style>
